module.exports = __webpack_public_path__ + "images/onboarding-banner/Taco.06585396b5a38f088d80.svg";